export type { StripBannerCustomisableProps } from './StripBannerCustomisable'
export { StripBannerCustomisable } from './StripBannerCustomisable'
